/**
 * Manager invitation links made in this page, by event and invitation (`useEventHosts`): the create answer is the
 * only one that carries a link, and the Team view unmounts when the workspace switches views, so they live here until
 * the page closes, or until whoever made them signs out (AuthContext's `logout`), so the next person on this tab
 * never finds them.
 */
const madeLinks = new Map<string, Record<string, string>>()

/** The links this page made for `eventId`'s invitations, by invitation id. */
export const madeLinksFor = (eventId: string): Record<string, string> => madeLinks.get(eventId) ?? {}

/** Keeps a link this page made; resolves to the event's links with it. */
export function keepMadeLink(eventId: string, invitationId: string, url: string): Record<string, string> {
  const kept = { ...madeLinksFor(eventId), [invitationId]: url }
  madeLinks.set(eventId, kept)
  return kept
}

/** Forgets every link this page made. */
export function forgetMadeLinks() {
  madeLinks.clear()
}
